import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import apiBet from "./js/apiBet";
import axios from "axios";
import i18n from "./i18nextConf";

export default function LiveTVGLS() {
    const [searchParams] = useSearchParams();

    const ch = searchParams.get("Channel");

    const [url, setUrl] = useState("");

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();

        async function fetchData() {
            try {
                var stk = searchParams.get("id");
                //setIsCompleted(false);
                const token = localStorage.getItem("a-token");
                apiBet.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                apiBet.defaults.headers.common["x-lang"] = i18n.language;
                await apiBet
                    .get(`getTV?tv=${ch}`, { cancelToken: cancelToken.token })
                    .then((res) => {
                        //console.log(res.data.data);
                        setUrl(res.data.llx);
                    })
                    .catch((err) => {
                        if (axios.isCancel(err)) {
                            //console.log("cancel");
                            setUrl("");
                        }
                    });
                //setIsCompleted(true);
            } catch (error) {
                //setIsCompleted(true);
                setUrl("");
            }
        }
        fetchData();
        return () => {
            cancelToken.cancel();
        };
    }, [ch]);

    return (
        <div style={{ height: "100vh", overflow: "hidden" }}>
            <iframe
                src={url}
                width="100%"
                height="100%"
                style={{ border: "none", overflow: "hidden" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer"
                sandbox="allow-scripts allow-same-origin allow-forms"
            ></iframe>
        </div>
    );
}